import { render, staticRenderFns } from "./PixelsForm.placements.vue?vue&type=template&id=2361b35a&scoped=true&lang=html&"
import script from "./PixelsForm.placements.vue?vue&type=script&lang=js&"
export * from "./PixelsForm.placements.vue?vue&type=script&lang=js&"
import style0 from "./PixelsForm.placements.vue?vue&type=style&index=0&id=2361b35a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2361b35a",
  null
  
)

export default component.exports